import { Box, Typography } from "@mui/material";
import coverImage from "../../../../media/images/headCover.svg";

export default function NotifsMain() {
  return (
    <>
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          borderRadius: "20px",
          justifyContent: "end",
          paddingX: "16px",
          marginBottom: "12px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "60px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          اعلان‌ها{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "16px",
            color: "background.default",
          }}
        >
          آخرین بروزرسانی: دهم اسفند 1402 - 1402/12/10{" "}
        </Typography>
      </Box>

      {/* <CustomTopTabbar
        setValue={setActiveTab}
        value={activeTab}
        tabs={["همه", "حساب کاربری", "اطلاعیه"].map((item, index) => (
          <NotifTabButton
            counts={0}
            label={item}
            active={index === activeTab}
          />
        ))}
      > */}
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>اعلانی وجود ندارد!</Typography>
      </Box>
      {/* <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>اعلانی وجود ندارد!</Typography>
      </Box>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography>اعلانی وجود ندارد!</Typography>
      </Box> */}
      {/* </CustomTopTabbar> */}
      {/* <NotifTabbar /> */}
      {/* <Box
        sx={{
          // border: "1px solid gray",
          display: "flex",
          flex: "1",
          flexDirection: "column",
          gap: "20px",
          overflowY: "scroll",
          paddingX: "8px",
          paddingY: "8px",
        }}
      >
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
        <NotifCard />
      </Box> */}
    </>
  );
}
